import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  AcondicionamientoControllerService,
  CodigoLerControllerService,
  CodigoOperacionFilterDTO,
  PtoRecogidaCodigoControllerService,
  PtoRecogidaCodigoFilterDTO,
  PtoRecogidaCodigoPayloadDTO,
  PuntoRecogidaControllerService,
} from 'api-rest';
import { SpinnerService } from '../../../services/spinner.service';
import { SnackbarService } from '../../../services/snackbar.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { MatDialog } from '@angular/material/dialog';
import { Attribute } from '@angular/core';
import { ParseCurrencyPipe } from '../../../share/components/pipe/ParseCurrency.pipe';
import { FormatCurrencyPipe } from '../../../share/components/pipe/FormatCurrency.pipe';
import {AcondicionamientoFilterDTO} from "../../../../../../dist/api-rest/api-puntosrecogida";

@Component({
  selector: 'app-collection-points-codeLer-manager',
  templateUrl: './collection-points-codeLer-manager.component.html',
  styleUrls: ['./collection-points-codeLer-manager.component.scss'],
})
export class CollectionPointsCodeLerManagerComponent implements OnInit {
  @Input() puntoRecogidaInfo!: any;
  @Output() public refrescarPuntosRecogidaEvent = new EventEmitter<any>();

  formGroup!: FormGroup;
  codigosLerEndpoint =
    this.environment.urlBackCore + 'api/v1/core/codigo-ler/filtro-combo?ptosRecogida=true';

  grid: any[] = [];
  operacionArray: any[] = [];

  pageNumber: number = 0;
  pageSize: number = 100;
  recordsTotal: number = 0;
  gestionArray: any[] = [];
  acondicionamientoArray: any[] = [];

  updateList: boolean = false;
  savingData:boolean = false;
  flagDisabledForm: boolean = false;

  periodicidadOptionArray: any = [
    { description: 'Mensual' },
    { description: 'Trimestral' },
    { description: 'Semestral' },
    { description: 'Anual' },
  ];

  headArray: any[] = [
    {
      Head: 'Código LER y descripción de ENVALORA',
      FieldName: 'descripcionMCodLer',
      Tooltip: true,
    },
    {
      Head: 'Peligrosidad',
      FieldName: 'codigoLer',
      renderValue: (item: any) => (item.codigoLer.peligrosidad ? 'SI' : 'NO'),
    },
    {
      Head: 'Cantidad Estimada (Kg/año)',
      FieldName: 'cantidadEstimada',
      renderValue: (item: any) =>
        this.formatCurrencyPipe.transform(item.cantidadEstimada),
    },
    {
      Head: 'Periodicidad de Traslados',
      FieldName: 'periodicidad',
    },
    {
      Head: 'Acondicionamiento',
      FieldName: 'acondicionamiento',
      Attribute: 'descripcion',
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: { params: 'canAccessDelete', accion: 'delete' },
        },
      ],
      width: '2',
      permanent: true,
    },
  ];

  filteredOptions: any = [
    { description: 'Mensual' },
    { description: 'Trimestral' },
    { description: 'Semestral' },
    { description: 'Anual' },
  ];

  constructor(
    private formBuilder: FormBuilder,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    @Inject('environment') private environment: any,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private puntoRecogidaControllerService: PuntoRecogidaControllerService,
    private acondicionamientoControllerService: AcondicionamientoControllerService,
    private ptoRecogidaCodigoControllerService: PtoRecogidaCodigoControllerService,
    private parseCurrencyPipe: ParseCurrencyPipe,
    private formatCurrencyPipe: FormatCurrencyPipe
  ) {
    this.formGroup = this.formBuilder.group({
      codigoLer: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      cantidadKgA: [{ value: null, disabled: false }],
      periocidadTraslado: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      acondicionamiento: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
    });
  }

  ngOnInit() {
    this.comboAcondicionamiento();

    this.canAccessCodeLerViewEdit();

    this.formGroup.get('codigoLer')?.valueChanges.subscribe((value) => {
      this.updateOptions();
    });
  }

  updateOptions(): void {
    const peligrosidad = this.formGroup.get('codigoLer')?.value?.peligrosidad;
    this.formGroup.get('periocidadTraslado')?.reset();

    if (peligrosidad) {
      this.filteredOptions = this.periodicidadOptionArray.filter(
        (option: any) => option.description !== 'Anual'
      );
    } else {
      this.filteredOptions = [...this.periodicidadOptionArray];
    }
  }

  private getBackendFilter() {
    const backendFilter: PtoRecogidaCodigoFilterDTO = {
      ptoRecogida: { id: this.puntoRecogidaInfo?.id },
    };
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;

    return { backendFilter, page, size: this.pageSize };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.puntoRecogidaInfo) {
      const { backendFilter, page, size } = this.getBackendFilter();
      this.ptoRecogidaCodigoControllerService
        .findAllPtoRecogidaCodigo(backendFilter, { page, size })
        .subscribe({
          next: (response: any) => {
            this.grid = this.canAccessAll(response?.datos);
          },
          error: (err) => {},
        });
    }
  }

  getLerDescription(ler: any) {
    return ler?.tipoCodigo + ' - ' + ler?.descripcion;
  }

  getOperacionDescription(op: any) {
    return op?.descripcion;
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'codigoLer': {
        return this.formGroup.get('codigoLer') as FormControl;
        break;
      }
      default: {
        return this.formGroup.get('') as FormControl;
        break;
      }
    }
  }

  getObjectQuery(searchterm: string) {
    return {
      descripcion: searchterm
    };
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.formGroup.controls[controlName]?.touched ||
        this.formGroup.controls[controlName]?.dirty) &&
      this.formGroup.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }
  selPaginatorHasError(controlName: string) {
    if (
      (this.formGroup.controls[controlName]?.touched ||
        this.formGroup.controls[controlName]?.dirty) &&
      this.formGroup.controls[controlName]?.errors
    ) {
      return true;
    } else {
      return false;
    }
  }

  addPrevision() {
    if (!this.canAccessAgregar()) {
      return;
    }

    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      this.snackBarSrv.showSnackBar(
        'Debe completar los campos obligatorios',
        'error'
      );
      return;
    }
    if (!this.savingData) {
      this.savingData = true;
      const existe = this.grid.find(
        (x) =>
          x.codigoLer?.id === this.formGroup.get('codigoLer')?.value?.id &&
          x.acondicionamiento?.id ===
          this.formGroup.get('acondicionamiento')?.value?.id
          &&
          x.periodicidad === this.formGroup.get('periocidadTraslado')?.value.description &&
          x.cantidadEstimada == this.parseCurrencyPipe.transform(
            this.formGroup.get('cantidadKgA')?.value)
      );

      if (existe) {
        this.snackBarSrv.showSnackBar(
          'Ya existe el residuo autorizado introducido.',
          'error'
        );
        this.savingData = false;
      }
      else {

        const dataObjCode: PtoRecogidaCodigoPayloadDTO | any = {
          ptoRecogida: { id: this.puntoRecogidaInfo?.id },
          codigoLer: { id: this.formGroup.get('codigoLer')?.value?.id },
          cantidadEstimada: this.parseCurrencyPipe.transform(
            this.formGroup.get('cantidadKgA')?.value
          ),
          periodicidad:
            this.formGroup.get('periocidadTraslado')?.value?.description,
          acondicionamiento: {
            id: this.formGroup.get('acondicionamiento')?.value.id,
          },
        };

        this.ptoRecogidaCodigoControllerService
          .createPtoRecogidaCodigo(dataObjCode)
          .subscribe({
            next: (response: any) => {
              this.snackBarSrv.showSnackBar(
                'Los datos se han guardado correctamente.',
                'success'
              );
              this.refrescarPuntosRecogidaEvent.emit(true);
              this.formGroup.reset();
              this.savingData = false;
            },
            error: (err) => {
              this.savingData = false;

            },
          });
      }
    }
  }

  canAccessAgregar(): boolean {
    return (
      this.authService.can('ptosrecogida-codigos', 'create') &&
      this.puntoRecogidaInfo?.estado?.id !== 6
    );
  }

  action(event: any) {
    if (!this.canAccessDelete()) {
      return;
    }

    if (event.nameButton == 'delete') {
      this.confirmacionEliminarPrevision(event);
    }
  }

  canAccessDelete(): boolean {
    return (
      this.authService.can('ptosrecogida-codigos', 'delete') &&
      this.puntoRecogidaInfo?.estado?.id !== 6
    );
  }
  confirmacionEliminarPrevision(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar el código LER gestionado?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.ptoRecogidaCodigoControllerService
          .borrarPtoRecogidaCodigo(element?.id)
          .subscribe({
            next: (response: any) => {
              this.snackBarSrv.showSnackBar(
                'Se ha eliminado correctamente el código Ler',
                'success'
              );
              this.refrescarPuntosRecogidaEvent.emit(true);
            },
            error: (err) => {},
          });
      }
    });
  }

  comboAcondicionamiento() {
    let filter: AcondicionamientoFilterDTO = {};
    this.acondicionamientoControllerService.findAll2(filter,
      {
        sort: ['orden,asc']
      })
      .subscribe({
        next: (res) => {
          this.spinnerSrv.loadingHide();
          if (res) {
            this.acondicionamientoArray = res?.datos ?? [];
            ;
          }
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  showClearButton(formName: string): boolean {
    return this.formGroup.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.formGroup.get(formName)?.setValue(null);
  }

  canAccessAll(list: any) {
    const resultDelete = this.canAccessDelete();

    const listPermission = list.map((objeto: any) => {
      let descripcionMCodLer =
        objeto.codigoLer.tipoCodigo + ' ' + objeto.codigoLer.descripcion;

      return {
        ...objeto,
        descripcionMCodLer: descripcionMCodLer,
        canAccessDelete: resultDelete,
      };
    });

    return listPermission;
  }

  canAccessCodeLerViewEdit() {
    if (!this.canAccessCodeLerViewForm()) {
      this.flagDisabledForm = true;
      this.formGroup.disable();
    } else {
      this.flagDisabledForm = false;
    }
  }

  canAccessCodeLerViewForm() {
    return (
      this.authService.can('ptosrecogida-codigos', 'update') &&
      this.puntoRecogidaInfo?.estado?.id !== 6
    );
  }
}
